module.exports = {
    //API_LOCATION: 'https://iteam.org.ua/apiweb/dev_api.php' 
    API_LOCATION: 'https://lpr.iteam.org.ua/apiweb/dev_api.php' 
}